/**
 * Adresse de site tapée à la main → adresse complète, ou null si ce n'est pas un site.
 *
 * Personne ne tape « https:// » : « monentreprise.ca » devient
 * « https://monentreprise.ca ». Avant, le contrôle de l'étape 2 refusait une adresse
 * sans point ni « https:// », mais acceptait « https:// » suivi de n'importe quoi,
 * que le serveur jetait ensuite sans rien dire. Même règle que le serveur
 * (_normaliser_site) : il complète aussi, et refuse ce qui n'est pas une adresse.
 */
export function normaliserSite(saisie: string): string | null {
  let site = saisie.trim()
  if (!site) return null
  if (!/^https?:\/\//i.test(site)) site = `https://${site}`
  if (site.length > 255) return null
  let url: URL
  try {
    url = new URL(site)
  } catch {
    return null
  }
  // Un nom de domaine : un point et une fin d'au moins deux lettres (.ca, .com,
  // .québec, que le navigateur écrit xn--…).
  if (!/\.(\p{L}{2,}|xn--[a-z0-9-]+)$/iu.test(url.hostname)) return null
  const chemin = url.pathname === '/' ? '' : url.pathname
  return `${url.protocol}//${url.host}${chemin}${url.search}`
}
